import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

const UserLogin: React.FC = React.memo(function UserLogin() {
    return (
        <SvgIcon fontSize='small' viewBox='0 0 20 20'>
            <path
                d='M10 10C11.1218 10 12.0312 9.09058 12.0312 7.96875C12.0312 6.84692 11.1218 5.9375 10 5.9375C8.87817 5.9375 7.96875 6.84692 7.96875 7.96875C7.96875 9.09058 8.87817 10 10 10Z'
                fill='#C7CAD4'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M10.0001 18.125C12.1959 18.125 14.1883 17.254 15.6505 15.8386C17.1765 14.3615 18.125 12.2915 18.125 10C18.125 5.51269 14.4873 1.875 10 1.875C5.51269 1.875 1.875 5.51269 1.875 10C1.875 14.4873 5.5128 18.125 10.0001 18.125ZM10.0002 12.0312C7.94899 12.0312 6.13445 13.0448 5.03009 14.5983C3.91233 13.3908 3.22917 11.7752 3.22917 10C3.22917 6.26057 6.26057 3.22917 10 3.22917C13.7394 3.22917 16.7708 6.26057 16.7708 10C16.7708 11.7751 16.0878 13.3906 14.9702 14.598C13.8658 13.0446 12.0514 12.0312 10.0002 12.0312Z'
                fill='#C7CAD4'
            />
        </SvgIcon>
    )
})
export default UserLogin
